/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "omg": {
        "nested": {
          "firstparty": {
            "nested": {
              "FirstPartyTaxExtension": {
                "fields": {
                  "isSecondaryTax": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.omg?.nested?.firstparty?.nested?.FirstPartyTaxExtension) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE FirstPartyTaxExtension @ squareup/omg/firstparty/extensions.proto at 14:1
 */
export const FirstPartyTaxExtension = $root.lookupType('squareup.omg.firstparty.FirstPartyTaxExtension');
fixType(FirstPartyTaxExtension);
Builder.createAndAttachToType(FirstPartyTaxExtension);
